import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import b from 'b_';
import ConsoleNavigationStore from '../../stores/ConsoleNavigationStore';
import AdminActivityModal from '../AdminActivityModal/AdminActivityModal';
import SideNavigation from '../SideNavigation/SideNavigation';
import FuseConsoleTopBar from './FuseConsoleTopBar';
import './ConsoleLayout.css';

const block = b.lock('ConsoleLayout');

class ConsoleLayout extends Component {
    static propTypes = {
        consoleNavigation: ConsoleNavigationStore.PropType.isRequired,
    };

    render() {
        const pinned = this.props.consoleNavigation.pinned.isTrue;

        return <div className={block()}>
            <div className={block('Head')}>
                <FuseConsoleTopBar />
            </div>
            <div className={block('Body')}>
                <div className={block('Navigation', { pinned })}>
                    <SideNavigation />
                </div>
                <div className={block('Content')}>
                    {this.props.children}
                </div>
            </div>
            <AdminActivityModal />
        </div>;
    }
}

export default inject('consoleNavigation')(observer(ConsoleLayout));
